import axios from 'axios';
import { getBaseApiUrl, getRequestHeaders } from '../util/config';

export const getFAQs = async (
  category = 'all',
  searchCriteria = '',
  topThreeOnly = false
) =>
  await axios.get(
    `${getBaseApiUrl()}/Contentful/FAQs/${category}?searchCriteria=${searchCriteria}&topThreeOnly=${topThreeOnly}`,
    {
      headers: getRequestHeaders(),
    }
  );

export const getFAQ = async slug =>
  await axios.get(`${getBaseApiUrl()}/Contentful/FAQ/?slug=${slug}`, {
    headers: getRequestHeaders(),
  });
